var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { combineLatest } from 'rxjs';
import { useFeatureContext } from '@veeam/core';
import { WizardHeader } from './WizardHeader';
import { Panel, Tabs } from './WizardDialog';
import { View, VIEW_CONTENT_MOD, INDENT } from "../View";
import { ACTION_VIEW, Dialog } from "../Dialog";
import { TabList } from "../TabList";
import { WIZARD_SIZE } from './types';
import { KeyCode, createUIElement, SPACING_M } from "../helpers";
var WizardBody = styled(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n    padding-top: ", ";\n"], ["\n    height: 100%;\n    padding-top: ", ";\n"])), function (_a) {
    var hasTopPadding = _a.hasTopPadding;
    return (hasTopPadding ? SPACING_M : '0');
});
var createEnableStepsSchema = function (steps) {
    var schema = {};
    for (var idx = 0; idx < steps.length; idx++) {
        var step = steps[idx];
        schema[step.tag] = true;
        if (step.form && !step.form.isValid()) {
            break;
        }
    }
    return schema;
};
export var Wizard = createUIElement('Wizard', function (_a, ref) {
    var className = _a.className, id = _a.id, loading = _a.loading, onRequestClose = _a.onRequestClose, header = _a.header, _b = _a.width, width = _b === void 0 ? WIZARD_SIZE.m : _b, _c = _a.height, height = _c === void 0 ? WIZARD_SIZE.m : _c, tabWidth = _a.tabWidth, steps = _a.steps, onStepChange = _a.onStepChange, _d = _a.initialStepIdx, initialStepIdx = _d === void 0 ? 0 : _d, onDone = _a.onDone, canSave = _a.canSave, buttons = _a.buttons, _e = _a.hasTopPadding, hasTopPadding = _e === void 0 ? true : _e, _f = _a.hasKeyboardInteractive, hasKeyboardInteractive = _f === void 0 ? true : _f, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "id", "loading", "onRequestClose", "header", "width", "height", "tabWidth", "steps", "onStepChange", "initialStepIdx", "onDone", "canSave", "buttons", "hasTopPadding", "hasKeyboardInteractive", "onKeyPress", "style"]);
    var dataSelectorId = rest['data-selector-id'] || 'wizard';
    var t = useFeatureContext().t;
    var btns = buttons || {};
    btns.prev = btns.prev || t('wizard|actions|previous') || 'Previous';
    btns.next = btns.next || t('wizard|actions|next') || 'Next';
    btns.done = btns.done || t('wizard|actions|done') || 'Finish';
    btns.cancel = btns.cancel || t('wizard|actions|cancel') || 'Cancel';
    for (var idx = initialStepIdx; idx < steps.length; idx++) {
        if (!steps[idx].hidden && !steps[idx].disabled) {
            initialStepIdx = idx;
            break;
        }
    }
    var _g = useState(initialStepIdx), currentStepIdx = _g[0], setStep = _g[1];
    var currentStep = steps[currentStepIdx];
    if (!currentStep) {
        return null;
    }
    var _h = useState(createEnableStepsSchema(steps)), enableStepsSchema = _h[0], setEnableStepsSchema = _h[1];
    useEffect(function () {
        var stepFormObservers = steps
            .map(function (step) { return step.form && step.form.asObserver(); })
            .filter(Boolean);
        var subscription = combineLatest(stepFormObservers).subscribe(function () {
            setEnableStepsSchema(createEnableStepsSchema(steps));
        });
        return function () { return subscription.unsubscribe(); };
    }, []);
    var hasPrevStep = function () {
        var idx = currentStepIdx - 1;
        for (; idx >= 0; idx--) {
            if (!steps[idx].disabled && !steps[idx].hidden) {
                break;
            }
        }
        return !!steps[idx] && !steps[idx].disabled;
    };
    var nextStep = steps[currentStepIdx + 1];
    var validateStep = function (idx) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, step, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isValid = true;
                    step = steps[idx];
                    if (step.hidden || step.disabled) {
                        return [2 /*return*/, true];
                    }
                    if (!(step.form && step.form.submit)) return [3 /*break*/, 2];
                    return [4 /*yield*/, step.form.submit()];
                case 1:
                    _b.sent();
                    isValid = step.form.isValid();
                    _b.label = 2;
                case 2:
                    if (!(isValid && step.validate)) return [3 /*break*/, 5];
                    _a = isValid;
                    if (!_a) return [3 /*break*/, 4];
                    return [4 /*yield*/, step.validate()];
                case 3:
                    _a = (_b.sent());
                    _b.label = 4;
                case 4:
                    isValid = _a;
                    _b.label = 5;
                case 5: return [2 /*return*/, isValid];
            }
        });
    }); };
    var validateSteps = function (startIdx, endIdx) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isValid = true;
                    i = startIdx;
                    _a.label = 1;
                case 1:
                    if (!(i <= endIdx)) return [3 /*break*/, 4];
                    return [4 /*yield*/, validateStep(i)];
                case 2:
                    isValid = _a.sent();
                    if (!isValid) {
                        setStep(i);
                        return [3 /*break*/, 4];
                    }
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, isValid];
            }
        });
    }); };
    var selectHandler = function (selectIdx, direction) {
        if (direction === void 0) { direction = 0; }
        return __awaiter(void 0, void 0, void 0, function () {
            var canSelect, idx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        canSelect = true;
                        if (steps[selectIdx].disabled) {
                            idx = selectIdx + direction;
                            for (; idx < steps.length && idx >= 0; idx += direction) {
                                if (!steps[idx].disabled) {
                                    selectIdx = idx;
                                    break;
                                }
                            }
                            if (idx === steps.length || idx < 0) {
                                return [2 /*return*/];
                            }
                        }
                        if (!(selectIdx > currentStepIdx)) return [3 /*break*/, 2];
                        return [4 /*yield*/, validateSteps(currentStepIdx, selectIdx - 1)];
                    case 1:
                        canSelect = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!canSelect) {
                            return [2 /*return*/];
                        }
                        setStep(selectIdx);
                        if (onStepChange) {
                            onStepChange(steps[selectIdx].tag, steps[currentStepIdx].tag);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var nextHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var nextIdx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nextIdx = currentStepIdx + 1;
                    return [4 /*yield*/, selectHandler(nextIdx, 1)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var prevHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var prevIdx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    prevIdx = currentStepIdx - 1;
                    return [4 /*yield*/, selectHandler(prevIdx, -1)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var doneHandler = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isValid = true;
                    if (!canSave) return [3 /*break*/, 2];
                    if (!(currentStepIdx < steps.length - 1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, validateSteps(currentStepIdx, steps.length - 1)];
                case 1:
                    isValid = _a.sent(); // last (summary) step should be validated, too
                    _a.label = 2;
                case 2:
                    if (isValid && onDone) {
                        onDone();
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [currentStepIdx, onStepChange]);
    var enterKeyHandler = function () {
        if (!hasKeyboardInteractive || loading) {
            return;
        }
        if (nextStep) {
            nextHandler();
            return;
        }
        doneHandler();
    };
    var items = [];
    steps.forEach(function (_a, idx) {
        var hidden = _a.hidden, tag = _a.tag, disabled = _a.disabled, tabTitle = _a.tabTitle;
        if (!hidden) {
            items.push({
                id: "tab-" + idx,
                active: idx === currentStepIdx,
                disabled: disabled || !enableStepsSchema[tag],
                onClick: function () {
                    if (!disabled && enableStepsSchema[tag]) {
                        selectHandler(idx);
                    }
                },
                title: tabTitle
            });
        }
    });
    return (React.createElement(Dialog, __assign({}, rest, { "data-selector-id": dataSelectorId, className: "vm-Wizard " + className, ref: ref, id: id, hasSpacing: false, loading: loading, header: header, hasTopPadding: hasTopPadding, deactivate: onRequestClose, actions: [
            hasPrevStep() && {
                id: 'previous',
                text: btns.prev,
                view: ACTION_VIEW.alternate,
                onClick: prevHandler
            },
            !!nextStep && {
                id: 'next',
                text: btns.next,
                view: ACTION_VIEW.primary,
                onClick: nextHandler
            },
            (!nextStep || canSave) && {
                id: 'done',
                text: btns.done,
                view: ACTION_VIEW.primary,
                onClick: doneHandler
            },
            {
                id: 'cancel',
                text: btns.cancel,
                view: 'secondary',
                onClick: onRequestClose
            }
        ].filter(Boolean), size: {
            width: width,
            height: height
        }, onRequestClose: onRequestClose, onKeyPress: function (e) {
            if (e.keyCode === KeyCode.Enter) {
                enterKeyHandler();
            }
            onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(e);
        }, style: style }),
        React.createElement(Tabs, null,
            React.createElement(TabList, { "data-selector-id": dataSelectorId + "-tabs", width: tabWidth, items: items }),
            !currentStep.hidden && (React.createElement(Panel, null,
                React.createElement(WizardHeader, { title: currentStep.title, description: currentStep.description }),
                React.createElement(WizardBody, { hasTopPadding: hasTopPadding, spaceHorizontal: INDENT.m, spaceBottom: INDENT.m, root: true, clipped: true, hasYScroll: true, contentMod: VIEW_CONTENT_MOD.fill }, currentStep.body))))));
});
var templateObject_1;
//# sourceMappingURL=Wizard.js.map